import React, { useEffect } from "react";
import Select from "components/select";

import InputField from "components/fields/InputField";
import { useDispatch, useSelector } from "react-redux";
import {
  setEdit,
  nextStudent,
  setAttendanceDate,
  setAttendanceStatus,
  createAttendance,
  setCurrentEval,
  setCurrentPoint,
  setExam,
  createEval,
  createAdditionalPoint,
  createFinalPoint,
  setTabValue,
} from "../../services/journalSlice";
import "./GoodModal.scss";

export default function GoodModal() {
  const dispatch = useDispatch();
  const modalState = useSelector(({ JournalApp }) => JournalApp.journal);

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        dispatch(setEdit(false));
      }
      if (event.key === "Tab") {
        event.preventDefault();
        if (modalState.tabValue === 0) dispatch(createAttendance());
        if (modalState.tabValue === 1) dispatch(createEval());
        if (modalState.tabValue === 2) dispatch(createAdditionalPoint());
        dispatch(nextStudent());

        // dispatch(setEdit(true));
      }
      if (event.key === "Enter") {
        event.preventDefault();
        if (modalState.tabValue === 0) dispatch(createAttendance());
        if (modalState.tabValue === 1) dispatch(createEval());
        if (modalState.tabValue === 2) dispatch(createAdditionalPoint());
        dispatch(setEdit(false));
      }

      if (modalState.tabValue === 0) {
        if (event.key === "1") {
          dispatch(setAttendanceStatus(1));
        }
        if (event.key === "2") {
          dispatch(setAttendanceStatus(2));
        }
        if (event.key === "3") {
          dispatch(setAttendanceStatus(3));
        }
        if (event.key === "4") {
          dispatch(setAttendanceStatus(4));
        }
      }
    };
    if (modalState.edit) document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [
    modalState.tabValue,
    // ATTENDANCE LOGIC
    modalState.edit,
    modalState.currentStudentId,
    dispatch,
  ]);

  function formatDate(inputDate) {
    // Convert input string to a Date object
    const date = new Date(inputDate);
    // Extract year, month, and day
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const day = date.getDate().toString().padStart(2, "0");
    // Create the formatted date string
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  }

  const createDates = () => {
    let startDate = new Date(modalState.teacherData?.start);
    let endDate = new Date(modalState.teacherData?.end);
    let looper = startDate;
    let dateArray = [];
    let index = 1;
    while (looper >= startDate && looper <= endDate) {
      dateArray.push(looper);
      looper = new Date(startDate.getTime() + index * 7 * 24 * 60 * 60 * 1000);
      index++;
    }
    return dateArray;
  };

  const studentList = modalState.studentData.course;
  let currentStudent;
  if (modalState.tabValue === 0) {
    currentStudent = Object.values(studentList)[modalState.currentStudentId];
  }
  if (modalState.tabValue === 1) {
    currentStudent =
      modalState.examData.Class.course[modalState.currentStudentId];
  }
  if (modalState.tabValue === 2) {
    currentStudent = modalState.journal.course[modalState.currentStudentId];
  }
  if (modalState.tabValue === 3) {
    currentStudent = modalState.journal.course[modalState.currentStudentId];
  }
  return (
    <div className={"good-modal " + modalState.edit}>
      <div className="modal-content">
        {/* ATTENDANCE SCREEN */}
        {modalState.tabValue === 0 && (
          <>
            <div className="m-5">
              <div></div>
              <div className="p-5 font-bold">Сурагчын ирц бүртгэх</div>
              <Select
                id="text"
                value={modalState.attendanceDate}
                required={true}
                label="Ирцийн огноо"
                defaultText="Ирцын огноо сонгоно уу"
                onChange={(selected) => {
                  dispatch(setAttendanceDate(selected.target.value));
                }}
                children={
                  modalState.teacherData !== undefined &&
                  createDates().map((item, index) => (
                    <option value={formatDate(item)} key={index}>
                      {formatDate(item)}
                    </option>
                  ))
                }
              />
              <div className="p-5 font-bold">
                Ирц бүртгэх сурагчын нэр :
                {currentStudent?.firstname + " " + currentStudent?.lastname}
              </div>
              <Select
                id="number"
                value={modalState.attendanceStatus}
                required={true}
                label="Ирц"
                defaultText="Ирцийн төлөв сонгоно уу"
                onChange={(selected) => {
                  // setDate(selected.target.value);
                  dispatch(setAttendanceStatus(selected.target.value));
                }}
              >
                <option value={0}>Бүртгээгүй</option>
                <option value={3}>Ирсэн</option>
                <option value={4}>Тасалсан</option>
                <option value={1}>Өвчтэй</option>
                <option value={2}>Чөлөөтэй</option>
              </Select>
              <div className="pl-5">Хэрвээ keyboard аар оруулж байгаа бол</div>
              <div className="pl-5">1 - Өвчтэй</div>
              <div className="pl-5">2 - Чөлөөтэй</div>
              <div className="pl-5">3 - Ирсэн</div>
              <div className="pl-5">4 - Тасалсан</div>
              <div className="pl-5 ">
                гэж бүртгээд <span className="font-bold">TAB </span>товчлуурыг
                дарж хадгалж дараагийн сурагчийг харна эсвэл{" "}
                <span className="font-bold">ENTER </span>дарж хадгалж гарна
              </div>
            </div>
            <div className="submit flex p-5">
              <button
                title="Enter дарна уу"
                className="save"
                onClick={() => {
                  dispatch(createAttendance());
                  dispatch(setEdit(false));
                }}
              >
                + Бүртгэх
              </button>

              <button
                title="Enter дарна уу"
                className="cancel"
                onClick={() => {
                  dispatch(setEdit(false));
                }}
              >
                Гарах
              </button>
            </div>
          </>
        )}

        {modalState.tabValue === 1 && (
          <>
            <div className="m-5">
              <div></div>
              <div className="p-5 font-bold">
                Сурагчын шалгалтын дүн бүртгэх
              </div>
              <Select
                id="text"
                value={modalState.selectedExam}
                required={true}
                label="Шалгалтын нэр "
                defaultText="Шалгалтыг сонгоно уу"
                onChange={(selected) => {
                  dispatch(setExam(selected.target.value));
                }}
                children={modalState.examData.Exams.map((item, index) => (
                  <option value={item.id} key={index}>
                    {item.exam_name}
                  </option>
                ))}
              />
              <div className="p-5 font-bold">
                Шалгалтын дүн бүртгэх сурагчын нэр :
                {currentStudent?.firstname + " " + currentStudent?.lastname}
              </div>

              <label
                htmlFor={"test_result_label_for"}
                className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
              >
                Шалгалтын дүн
              </label>
              <InputField
                className="lg:w-100"
                value={modalState.currentEval}
                onChange={async (e) => {
                  await dispatch(setCurrentEval(e.target.value));
                }}
              />

              <div className="pl-5">
                Хэрвээ keyboard аар оруулж байгаа бол бүртгээд{" "}
                <span className="font-bold">TAB </span>товчлуурыг дарж хадгалж
                дараагийн сурагчийг харна эсвэл{" "}
                <span className="font-bold">ENTER </span>дарж хадгалж гарна
              </div>
            </div>
            <div className="submit flex p-5">
              <button
                title="Enter дарна уу"
                className="save"
                onClick={() => {
                  if (modalState.tabValue === 1) dispatch(createEval());
                  else dispatch(createAttendance());
                  dispatch(setEdit(false));
                }}
              >
                + Бүртгэх
              </button>

              <button
                title="Enter дарна уу"
                className="cancel"
                onClick={() => {
                  dispatch(setEdit(false));
                }}
              >
                Гарах
              </button>
            </div>
          </>
        )}

        {modalState.tabValue === 2 && (
          <>
            <div className="m-5">
              <div></div>
              <div className="p-5 font-bold">Сурагчын оролцоо бүртгэх</div>
              <div className="p-5 font-bold">
                Сурагчын нэр :
                {currentStudent?.firstname + " " + currentStudent?.lastname}
              </div>

              <label
                htmlFor={"input_result_label"}
                className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
              >
                Оролцооны дүнг оруулна уу
              </label>
              <InputField
                className="lg:w-100"
                type="number"
                value={modalState.extrapoint}
                onChange={(e) => {
                  dispatch(setCurrentPoint(e.target.value));
                }}
              />

              <div className="pl-5">
                Хэрвээ keyboard аар оруулж байгаа бол бүртгээд{" "}
                <span className="font-bold">TAB </span>товчлуурыг дарж хадгалж
                дараагийн сурагчийг харна эсвэл{" "}
                <span className="font-bold">ENTER </span>дарж хадгалж гарна
              </div>
            </div>
            <div className="submit flex p-5">
              <button
                title="Enter дарна уу"
                className="save"
                onClick={() => {
                  if (modalState.tabValue === 2)
                    dispatch(createAdditionalPoint());
                  dispatch(setEdit(false));
                }}
              >
                + Бүртгэх
              </button>

              <button
                title="Enter дарна уу"
                className="cancel"
                onClick={() => {
                  dispatch(setEdit(false));
                }}
              >
                Гарах
              </button>
            </div>
          </>
        )}
        {modalState.tabValue === 3 && (
          <>
            <div className="m-5">
              <div></div>
              <div className="p-5 font-bold">Сурагчын нийт дүнг бүртгэх</div>
              <div className="p-5 font-bold">
                Сурагчын нэр :
                {currentStudent?.firstname + " " + currentStudent?.lastname}
              </div>

              <label
                htmlFor={"total_label"}
                className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
              >
                Нийт дүнг оруулна уу
              </label>
              <InputField
                className="lg:w-100"
                type="number"
                value={modalState.extrapoint}
                onChange={(e) => {
                  dispatch(setCurrentPoint(e.target.value));
                }}
              />

              <div className="pl-5">
                Хэрвээ keyboard аар оруулж байгаа бол бүртгээд{" "}
                <span className="font-bold">TAB </span>товчлуурыг дарж хадгалж
                дараагийн сурагчийг харна эсвэл{" "}
                <span className="font-bold">ENTER </span>дарж хадгалж гарна
              </div>
            </div>
            <div className="submit flex p-5">
              <button
                title="Enter дарна уу"
                className="save"
                onClick={async () => {
                  if (modalState.tabValue === 3)
                    await dispatch(createFinalPoint());
                  await dispatch(setEdit(false));
                  await dispatch(setTabValue(2));
                }}
              >
                + Бүртгэх
              </button>

              <button
                title="Enter дарна уу"
                className="cancel"
                onClick={() => {
                  dispatch(setEdit(false));
                  dispatch(setTabValue(2));
                }}
              >
                Гарах
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
